import Vue from 'vue';
import Router from 'vue-router';

const Index = () => import('./views/index/index.vue'); // 首页
const Assistant = () => import('./views/assistant/index.vue'); // 助手
const Train = () => import('./views/train/index.vue'); // 培训
const Service = () => import('./views/service/index.vue'); // 服务
const InitiateRights = () => import('./views/service/Initiate-rights.vue'); // 发起维权
const RightsDetail = () => import('./views/service/rights-detail.vue'); // 维权详情
const ProveApply = () => import('./views/service/prove-apply.vue'); // 证明申请
const AnnualAssess = () => import('./views/service/annual-assess.vue'); // 年度考核信息
const AnnualChangeInfo = () => import('./views/service/annual-change-info.vue'); // 变更年度考核信息
const SelfRatingGrade = () => import('./views/service/self-rating-grade.vue'); // 填写自评等次
const PartyMemberPay = () => import('./views/service/party-member-payment.vue'); // 党员缴费确认
const Shopping = () => import('./views/shopping/index.vue'); // 商店
const Login = () => import('./views/login/index.vue'); // 登录
const Guide = () => import('./views/guide/index.vue'); // 引导页
const Notice = () => import('./views/notice/index.vue'); // 公告
const NoticeDetail = () => import('./views/notice/notice-detail.vue'); // 公告详情
const MyPower = () => import('./views/power/my-power.vue'); // 我的维权
const MyAssessment = () => import('./views/assessment/my-assessment.vue'); // 我的考核
const ShoppingEmbedded = () => import('./views/shopping/embedded-page.vue'); //商店内嵌空白页
const ForgetPwd = () => import('./views/login/forget-pwd.vue'); //忘记密码
const Assessment = () => import('./views/assessment/index.vue'); // 年度考核
const Statistics = () => import('./views/statistics/index.vue'); // 工时统计
const MyApply = () => import('./views/apply/my-apply.vue'); // 我的申请
const Member = () => import('./views/member/index.vue'); // 会员卡
const MemberRecord = () => import('./views/member/member-record.vue'); // 使用记录
const Center = () => import('./views/center/index.vue'); //个人中心
const CenterMsg = () => import('./views/center/message.vue'); //消息
const CenterInfo = () => import('./views/center/information.vue'); //个人信息编辑
const TimeRecords = () => import('./views/assistant/time-records.vue'); //记录工时
import vuex from '@/store/index';

// const Examplefirst = () => import('./views/example1.vue');

Vue.use(Router);
const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      title: '首页',
      navName: 'index'
    }
  },
  {
    path: '/assistant',
    name: 'Assistant',
    component: Assistant,
    meta: {
      title: '助手',
      navName: 'assistant',
      hasnav: true,
      getshowBack: true
    },
    nav: {}
  },
  {
    path: '/train',
    name: 'Train',
    component: Train,
    meta: {
      title: '培训',
      navName: 'train'
    },
    nav: {}
  },
  {
    path: '/service',
    name: 'Service',
    component: Service,
    meta: {
      title: '服务',
      navName: 'service',
      hasnav: true,
      getshowBack: true
    },
    nav: {}
  },
  {
    path: '/initiate-rights',
    name: 'InitiateRights',
    component: InitiateRights,
    meta: {
      title: '发起维权',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/rights-detail',
    name: 'RightsDetail',
    component: RightsDetail,
    meta: {
      title: '维权详情',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/prove-apply',
    name: 'ProveApply',
    component: ProveApply,
    meta: {
      title: '证明申请',
      hasnav: true,
      rightBtnText: '我的申请',
      url: './#/myApply'
    },
    nav: {}
  },
  {
    path: '/annual-assess',
    name: 'AnnualAssess',
    component: AnnualAssess,
    meta: {
      title: '发起考核',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/annual-change-info',
    name: 'AnnualChangeInfo',
    component: AnnualChangeInfo,
    meta: {
      title: '变更信息',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/self-rating-grade',
    name: 'selfRatingGrade',
    component: SelfRatingGrade,
    meta: {
      title: '发起考核',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/party-member-pay',
    name: 'PartyMemberPay',
    component: PartyMemberPay,
    meta: {
      title: '党员服务',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/time-records',
    name: 'TimeRecords',
    component: TimeRecords,
    meta: {
      title: '记录工时',
      hasnav: true,
      url: './#/statistics',
      rightBtnText: true,
      rightIcon: 'icon-statistics'
    },
    nav: {}
  },
  {
    path: '/shopping',
    name: 'Shopping',
    component: Shopping,
    meta: {
      title: '商城',
      navName: 'shopping',
      hasnav: true,
      getshowBack: true
    },
    nav: {}
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录'
    },
    nav: {}
  },
  {
    path: '/guide',
    name: 'guide',
    component: Guide,
    meta: {
      title: '引导页'
    },
    nav: {}
  },
  {
    path: '/notice',
    name: 'notice',
    component: Notice,
    meta: {
      title: '通知公告',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/noticeDetail',
    name: 'noticeDetail',
    component: NoticeDetail,
    meta: {
      title: '通知公告',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/myPower',
    name: 'myPower',
    component: MyPower,
    meta: {
      title: '我的维权',
      hasnav: true,
      changeColor: true
    },
    nav: {}
  },
  {
    path: '/myAssessment',
    name: 'myAssessment',
    component: MyAssessment,
    meta: {
      title: '我的考核',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/assessment',
    name: 'assessment',
    component: Assessment,
    meta: {
      title: '年度考核',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/shoppingEmbedded',
    name: 'shoppingEmbedded',
    component: ShoppingEmbedded,
    meta: {
      title: '商店',
      navName: 'shoppingEmbedded',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/forgetPwd',
    name: 'forgetPwd',
    component: ForgetPwd,
    meta: {
      title: '忘记密码',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: Statistics,
    meta: {
      title: '工时统计',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/myApply',
    name: 'myApply',
    component: MyApply,
    meta: {
      title: '我的申请',
      hasnav: true,
      changeColor: true
    },
    nav: {}
  },
  {
    path: '/memberRecord',
    name: 'memberRecord',
    component: MemberRecord,
    meta: {
      title: '使用记录',
      hasnav: true
    },
    nav: {}
  },
  {
    path: '/member',
    name: 'member',
    component: Member,
    meta: {
      title: '电子会员卡',
      hasnav: true,
      url: './#/memberRecord',
      rightBtnText: '使用记录',
      changeColor: true
    },
    nav: {}
  },
  {
    path: '/centerInfo',
    name: 'centerInfo',
    component: CenterInfo,
    meta: {
      title: '完善个人信息',
      hasnav: true,
      rightBtnText: '保存',
      leftBtn: '取消'
    },
    nav: {}
  },
  {
    path: '/centerMsg',
    name: 'centerMsg',
    component: CenterMsg,
    meta: {
      title: '消息',
      hasnav: true,
      rightBtnText: '全部已读'
    },
    nav: {}
  },
  {
    path: '/center',
    name: 'center',
    component: Center,
    meta: {
      title: '个人中心',
      hasnav: true,
      url: './#/centerInfo',
      rightBtnText: true,
      rightIcon: 'icon-setup',
      changeColor: true
    },
    nav: {}
  }
];

let router = new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return {
        x: 0,
        y: 0
      };
    } else {
      return savedPosition;
    }
  }
});

export default router;

router.beforeEach((to, from, next) => {
  setTitle(to, from, next);
  ctrlNavBar(to, from, next);
  ctrlTabBar(to, from, next);
  next();
});

function ctrlTabBar(to, from, next) {
  if (to.meta.navName) {
    //需要navBar的页面
    vuex.dispatch('AgettabberSwite', true);
    vuex.dispatch('AgetnavbarText', to.meta.navName);
  } else {
    vuex.dispatch('AgettabberSwite', false);
  }
}
function ctrlNavBar(to, from, next) {
  console.log(to.nav);
  if (to.meta.hasnav) {
    vuex.dispatch('AgetnavberSwite', true);
    vuex.dispatch('AgettitleText', to.meta.title);
    if (to.meta.getshowBack) {
      vuex.dispatch('AgetshowBack', false);
    } else {
      vuex.dispatch('AgetshowBack', true);
    }
    if (to.meta.rightBtnText) {
      vuex.dispatch('AgetrightBtnText', to.meta.rightBtnText);
    } else {
      vuex.dispatch('AgetrightBtnText', '');
    }
    if (to.meta.url) {
      vuex.dispatch('AgetnavUrl', to.meta.url);
    } else {
      vuex.dispatch('AgetnavUrl', 'javascript:;');
    }
    if (to.meta.leftBtn) {
      vuex.dispatch('AgetleftBtn', to.meta.leftBtn);
    } else {
      vuex.dispatch('AgetleftBtn', '');
    }
    if (to.meta.changeColor) {
      vuex.dispatch('AgetchangeColor', to.meta.changeColor);
    } else {
      vuex.dispatch('AgetchangeColor', false);
    }
    if (to.meta.rightIcon) {
      vuex.dispatch('AgetrightIcon', to.meta.rightIcon);
    } else {
      vuex.dispatch('AgetrightIcon', false);
    }
  } else {
    vuex.dispatch('AgetnavberSwite', false);
  }
}

function setTitle(to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    let str = /\(i[^;]+;( U;)? CPU.+Mac OS X/;
    if (navigator.userAgent.match(str)) {
      const hackIframe = document.createElement('iframe');
      hackIframe.style.display = 'none';
      hackIframe.src = '/fixIosTitle.html?r=' + Math.random();
      document.body.appendChild(hackIframe);
      setTimeout(_ => {
        document.body.removeChild(hackIframe);
      }, 300);
    }
  }
}
